import Column from '@components/Column';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { StampCardRow } from '@models/stamp';
import { useTranslation } from 'react-i18next';

import FullCard from './FullCard';
import useCardExpand from './hooks/useCardExpand';
import StampLog from './StampLog';
import StampProgress from './StampProgress';
import SummaryCard from './SummaryCard';

interface Props {
    stampCard: StampCardRow;
}

function StampCard({ stampCard }:Props) {
    const { t } = useTranslation('stamp');
    const {
        shopName, shopId, stampCount,
    } = stampCard;
    const {
        handleExpand, expand, logExpand, ref, setLogExpand,
    } = useCardExpand(shopId);

    return (
        <Column fullWidth spacing={16}
            ref={ref}>
            <Anchor/>
            {expand && (
                <StampProgress stampCard={stampCard}
                    logExpand={logExpand}
                    setLogExpand={setLogExpand} />
            )}
            <Container
                aria-label='stamp-card'
                onClick={handleExpand}>
                {expand && (
                    <Tooltip right='unset'
                        visibleKey='stampUsage'
                        top={-34}
                        align='left'
                        backgroundColor={colors.gray3}
                        color={colors.gray9}
                        left={12}>
                        {t('card.tooltip')}
                    </Tooltip>
                )}
                <SummaryCard count={stampCount}
                    shopName={shopName}
                    hide={expand} />
                <FullCard stampCard={stampCard}
                    expand={expand} />
                <ShopWrapper>
                    <Text fontWeight='bold'>
                        {shopName}
                    </Text>
                </ShopWrapper>
                <StampLog shopId={shopId} expand={logExpand} />
            </Container>
        </Column>
    );
}

const Anchor = styled.div`
    margin-top: -70px;
    padding-bottom: 70px;
`;

const Container = styled.div`
    min-height: 54px;
    position: relative;
    width: 100%;
`;

const ShopWrapper = styled.div`
    position: absolute;
    right: 8px;
    top: -6px;
`;

export default StampCard;
